const escapeStringRegex = (string) => string.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
const mongoRegex = (string, options) => ({ $regex: `.*${escapeStringRegex(string)}.*`, $options: options });
const mongoRegexI = (string) => mongoRegex(string, 'i');

const mongoNotRegex = (string, options) => {
  if (string.charAt(0) === '-') {
    return { $not: mongoRegex(string.substring(1), options) };
  }

  return mongoRegex(string, options);
};
const mongoListRegex = (prop, string, options) => {
  const chunks = string.split(',');
  if (chunks.length === 1) { return { [prop]: mongoNotRegex(string, options) }; }

  return { $and: chunks.map((chunk) => ({ [prop]: mongoNotRegex(chunk, options) })) };
};

export {
  mongoRegex, mongoRegexI, escapeStringRegex, mongoListRegex,
};
